import { useContext, useState } from 'react';
import DOMPurify from 'dompurify';
import { SiteContentContext } from '../context/SiteContentContext';
import QuestionModal from '../components/QuestionModal';
import Icon from '../components/Icon';
import { injectIymcsMark } from '../utils/richText';
import { useSeo } from '../hooks/useSeo';
import '../styles/fleet_page.css';

const safe = (html) => ({ __html: injectIymcsMark(DOMPurify.sanitize(html || '')) });

const PricingPage = ({ isPreview = false }) => { // eslint-disable-line no-unused-vars
  useSeo({
    title: 'Цены',
    description: 'Стоимость обучения яхтингу, парусных путешествий и регат The Sailing Doctor. Что входит в цену и что оплачивается отдельно.',
  });
  const { content } = useContext(SiteContentContext);
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);

  const title = content.pricingTitle || 'О ценах';
  const subtitle = content.pricingSubtitle || 'Прозрачное ценообразование без скрытых платежей';
  const blocks = content.pricingBlocks || [];

  return (
    <main>
      <div className="fleet-page">
        <section
          className={`fleet-page-hero${content.pricingHeroImage ? ' has-cover' : ''}`}
          style={content.pricingHeroImage ? { backgroundImage: `url(${content.pricingHeroImage})` } : {}}
        >
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </section>

        <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px' }}>

          {/* Главный текст */}
          {content.pricingIntro && (
            <div className={content.pricingIntroWide ? 'intro-features-text--wide' : ''} style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--text, #333)', marginBottom: 40 }}>
              <div dangerouslySetInnerHTML={safe(content.pricingIntro)} />
            </div>
          )}

          {/* Три секции по типам: обучение / путешествия / гонки */}
          {[
            {
              label: 'Обучение',
              icon: <Icon name="graduation" size={22} />,
              included: content.pricingStudyIncluded,
              excluded: content.pricingStudyExcluded,
            },
            {
              label: 'Путешествия',
              icon: <Icon name="sail" size={22} />,
              included: content.pricingAdventureIncluded,
              excluded: content.pricingAdventureExcluded,
            },
            {
              label: 'Гонки',
              icon: <Icon name="trophy" size={22} />,
              included: content.pricingRaceIncluded,
              excluded: content.pricingRaceExcluded,
            },
          ].filter(s => s.included || s.excluded).map((section, i) => (
            <div key={i} className="pricing-section">
              <h2 className="pricing-section-title">{section.icon}{section.label}</h2>
              <div className="pricing-two-col">
                {section.included && (
                  <div className="pricing-block pricing-block--green">
                    <h3><Icon name="shield" size={20} /> Что включено в цену</h3>
                    <div dangerouslySetInnerHTML={safe(section.included)} />
                  </div>
                )}
                {section.excluded && (
                  <div className="pricing-block pricing-block--yellow">
                    <h3><Icon name="info" size={20} /> Что оплачивается отдельно</h3>
                    <div dangerouslySetInnerHTML={safe(section.excluded)} />
                  </div>
                )}
              </div>
            </div>
          ))}

          {/* Дополнительные блоки */}
          {blocks.map((block, i) => (
            <div key={i} style={{
              background: 'var(--card-bg, #fff)',
              border: '1px solid var(--border, #e8e8e8)',
              borderRadius: 12,
              padding: '22px 26px',
              marginBottom: 24,
            }}>
              <h2 style={{ marginTop: 0, color: 'var(--text-heading, #1a2a3a)' }}>{block.title}</h2>
              <div style={{ fontSize: 15, lineHeight: 1.8, color: 'var(--text, #444)' }}>
                <div dangerouslySetInnerHTML={safe(block.text)} />
              </div>
            </div>
          ))}

          {/* Финальный CTA-текст */}
          {content.pricingFooter && (
            <div className={content.pricingFooterWide ? 'intro-features-text--wide' : ''} style={{
              background: 'linear-gradient(135deg, #1a2a4a 0%, #2b3a6e 100%)',
              borderRadius: 14,
              padding: '28px 32px',
              color: '#fff',
              marginTop: 16,
            }}>
              <div style={{ fontSize: 15, lineHeight: 1.8, opacity: 0.9 }}>
                <div dangerouslySetInnerHTML={safe(content.pricingFooter)} />
              </div>
            </div>
          )}

        </div>
      </div>

      <section className="cta-section">
        <h2>{content.pricingCtaTitle || 'Есть вопросы по стоимости?'}</h2>
        {content.pricingCtaText
          ? <div className={content.pricingCtaTextWide ? 'intro-features-text--wide' : ''} dangerouslySetInnerHTML={safe(content.pricingCtaText)} />
          : <p>Напишите нам — ответим подробно и без обязательств.</p>}
        <button className="cta-button" onClick={() => setIsQuestionOpen(true)}>Задать вопрос</button>
      </section>

      <QuestionModal isOpen={isQuestionOpen} onClose={() => setIsQuestionOpen(false)} pageTitle="О ценах" />
    </main>
  );
};

export default PricingPage;
